import { useDispatch } from 'react-redux';
import { addPageContentItem, saveSnapshot } from '../../actions/wysiwyg/editor';
import { useTextBoxGenerator } from '../wysiwyg_editor/useTextBoxGenerator';

function useAddText(): () => void {
  const dispatch = useDispatch();
  const textBoxGenerator = useTextBoxGenerator();

  return () => {
    const newTextItem = textBoxGenerator();

    dispatch(saveSnapshot());
    dispatch(addPageContentItem(newTextItem));
  };
}

export default useAddText;
